import { Link } from 'react-router-dom'
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    services: [
      { name: 'CIO Advisory Services', href: '/services#cio-advisory' },
      { name: 'Disruptive Technologies', href: '/services#disruptive-tech' },
      { name: 'Application Automation', href: '/services#app-automation' },
      { name: 'Cloud Realization', href: '/services#cloud-realization' },
      { name: 'Get a Quote', href: '/services/quote' },
    ],
    solutions: [
      { name: 'On-Premise Solutions', href: '/solutions#on-premise' },
      { name: 'Cloud Native', href: '/solutions#cloud-native' },
      { name: 'Hybrid Solutions', href: '/solutions#hybrid' },
      { name: 'Cloud Migration', href: '/solutions#migration' },
    ],
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'Contact', href: '/contact' },
      { name: 'Partners', href: '/partners' },
      { name: 'Blog', href: '/blog' },
      { name: 'Careers', href: '/careers' },
    ]
  }

  const socialLinks = [
    { icon: Linkedin, href: 'https://linkedin.com/company/disruption-consulting', label: 'LinkedIn' },
    { icon: Twitter, href: 'https://x.com/DisruptionLLC', label: 'Twitter' },
  ]

  return (
    <footer className="relative z-20 bg-secondary-800 text-white">
      <div className="container-max section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="/images/logo/Logo-Disruption_Consulting.png"
                alt="Disruption Consulting Logo"
                className="w-32 h-auto object-contain"
                loading="lazy"
                width="128"
                height="40"
              />
            </div>
            <p className="text-sm text-white/75 leading-relaxed">
              Leading technology consulting firm specializing in disruptive solutions, 
              cloud migration, and digital transformation for enterprises worldwide.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-white/75">
                <Mail className="w-4 h-4" />
                <span>contactus@disruption.consulting</span>
              </div>
              <div className="flex items-center space-x-2 text-white/75">
                <Phone className="w-4 h-4" />
                <span>+1 (408) 634-9679</span>
              </div>
              <div className="flex items-center space-x-2 text-white/75">
                <MapPin className="w-4 h-4" />
                <span>San Francisco, CA</span>
              </div>
              <div className="flex items-center space-x-2 text-white/75">
                <MapPin className="w-4 h-4" />
                <span>Los Angeles, CA</span>
              </div>
               <div className="flex items-center space-x-2 text-white/75">
                <MapPin className="w-4 h-4" />
                <span>San Diego, CA</span>
              </div>
            </div>
          </div>

          {/* Services Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-display font-semibold text-primary-300">Services</h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-white/75 hover:text-primary-300 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-display font-semibold text-primary-300">Solutions</h4>
            <ul className="space-y-2">
              {footerLinks.solutions.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-white/75 hover:text-primary-300 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-display font-semibold text-primary-300">Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-white/75 hover:text-primary-300 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="flex space-x-4 pt-4">
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-white/10 hover:bg-primary-500 rounded-lg transition-colors duration-200"
                  aria-label={label}
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/15 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white text-sm">
            © {currentYear} Disruption Consulting. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <Link to="/privacy-policy" className="text-white hover:text-primary-300 transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className="text-white hover:text-primary-300 transition-colors duration-200">
              Terms of Use
            </Link>
            <Link to="/cookie-policy" className="text-white hover:text-primary-300 transition-colors duration-200">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer